// extracted by mini-css-extract-plugin
export default {"root":"root___ZSpxG","btns":"btns___ftffw","button":"button___PRbtb"};